import { useState } from "react"
import { IconButton } from "../atoms/buttons"
import { TextAtom } from "../atoms/TextAtom"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { AvatarBackgroundButton, AvatarButton, AvatarPositionButton } from "./avatarButton"
import { ImageSelectorModalCopy } from "../components/customModals"
import { color } from "chart.js/helpers"
import { position } from "polished"

export const AvatarSelection = ({ selectedAvatar, selectAvatar, avatars}) => {
    return (
        <VerticalLayout className="avatar-selection">
            <TextAtom
                title={"Selecteer een avatar"}
                style={{"marginBottom": "0.5rem"}}
                className={"standard-text-color full-width semi-bold"}
            />

            <HorizontalLayout className="full-width standard-margin-bottom">
                {avatars.map((avatar, index) => (
                    <AvatarButton
                        isSelected={selectedAvatar.id === avatar.id}
                        onClick={(event) => { event.stopPropagation(); selectAvatar(avatar); }}
                        key={`${index} - ${avatar.id}`} avatar={avatar} />
                ))
                }
            </HorizontalLayout>
        </VerticalLayout>

    )

}
export const AvatarBackgroundSelection = ({ selectedAvatar, selectAvatar, avatarsBackgrounds, setAvatarsBackgrounds }) => {
    const [backgroundModal, setBackgroundModal] = useState(false);
    const addBackground = (selection) => {
    const newBg = {
        id_background: 3,
        colors: selection.colors,
        alt: "Custom Gradient",
    };

    setAvatarsBackgrounds((prev) => {
        if (Array.isArray(prev)) {
        return prev.map((bg) =>
            bg.id_background === 3 ? newBg : bg
        );
        }
        return [newBg];
    });

    selectAvatar(newBg);
    setBackgroundModal(false);
    };
    return (
        <VerticalLayout className="avatar-selection">
            <TextAtom
                title={"Selecteer een achtergrond"}
                style={{"marginBottom": "0.5rem"}}
                className={"standard-text-color semi-bold full-width"}
            />
            <HorizontalLayout className="full-width standard-margin-bottom">
                {avatarsBackgrounds.map((avatar, index) => (
                    <AvatarBackgroundButton
                        isSelected={selectedAvatar.id_background === avatar.id_background}
                        onClick={(event) => { event.stopPropagation(); selectAvatar(avatar); }}
                        key={`${index} - ${avatar.id}`} avatar={avatar} />
                ))}
                <VerticalLayout style={{ margin: 0, padding: "0", width:"auto", height: "6rem", justifyContent: "flex-start", alignItems: "flex-start", }}>
                    <IconButton style={{ marginLeft: "0", }} onClick={(e) => { e.stopPropagation(); setBackgroundModal(true); }} className={"avatar-background-add standard-margin-left"} size={25} icon2={"plus"} />
                </VerticalLayout>
            </HorizontalLayout>
            <ImageSelectorModalCopy type="avatar-bg" visible={backgroundModal} dismiss={() => setBackgroundModal(false)} imageSelected={addBackground} />
        </VerticalLayout>
    )
}



export const AvatarPositionSelection = ({ selectedAvatar, selectAvatar }) => {
    const avatarsPositions = [
        { id: 1, title: "Links" },
        { id: 2, title: "Centrum" },
        { id: 3, title: "Rechts" },
    ]
    return (
        <VerticalLayout className="avatar-selection">
            <TextAtom
                title={"Avatar positie"}
                style={{"marginBottom": "0.5rem"}}
                className={"standard-text-color semi-bold full-width"}
            />
            <HorizontalLayout className="full-width standard-margin-bottom">
                {avatarsPositions.map((position, index) => (
                    <AvatarPositionButton
                        isSelected={selectedAvatar === position.id}
                        onClick={(event) => { event.stopPropagation(); selectAvatar(position.id); }}
                        key={`${index} - ${position.id}`} 
                        position={position} 
                    />
                ))}
            </HorizontalLayout>
        </VerticalLayout>
    )

}

